import { render, staticRenderFns } from "./table-details.vue?vue&type=template&id=38c72a5e&scoped=true&"
import script from "./table-details.vue?vue&type=script&lang=js&"
export * from "./table-details.vue?vue&type=script&lang=js&"
import style0 from "./table-details.vue?vue&type=style&index=0&id=38c72a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c72a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c72a5e')) {
      api.createRecord('38c72a5e', component.options)
    } else {
      api.reload('38c72a5e', component.options)
    }
    module.hot.accept("./table-details.vue?vue&type=template&id=38c72a5e&scoped=true&", function () {
      api.rerender('38c72a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/modules/table-details.vue"
export default component.exports